import NamedDto from 'modules/base/dto/NamedDto';

export class CalculateTaskEditDto extends NamedDto {
    constructor() {
        super();
        
        /** @type {number} */
        this.aspect = null;
        /** @type {String} */
        this.name = null;
    }

    /**
     * @typedef {Object} _CalculateTaskEditDtoProps
     * @property {number} aspect
     * @property {String} name
     * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _CalculateTaskEditDtoProps} CalculateTaskEditDtoProps
     */
    /**
     *
     * @param {CalculateTaskEditDtoProps} props
     * @returns {CalculateTaskEditDto}
     */

    setup(props) {
        super.setup(props);

        this.aspect = props.aspect;
        this.name = props.name;

        return this;
    }
}

export default CalculateTaskEditDto;